import CarCard from "components/card/CarCard";
import SearchBar from "components/common/SearchBar";
import { SideBarTabs } from "constants/tabs";
import AppCopy from "copy/AppCopy";
import { useTabActive } from "hook/useTabActive";
import React, { useEffect, useState } from "react";
import { CommonStyles } from "styles/CommonStyles";
import Menu from "components/common/Menu";
import useCars from "hook/useCars";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { CarType } from "types/loadedData";
import PageHeader from "components/common/PageHeader";
import EmptyState from "components/common/EmptyState";
import LoadMoreButton from "components/common/LoadMoreButton";

function CarsPage() {
  const { getCars } = useCars();
  const { cars } = useSelector((state: RootState) => state.car);
  const [searchValue, setSearchValue] = useState<string>("");
  const [loadedCars, setLoadedCars] = useState<CarType[]>(cars);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const loadData = async () => {
    await getCars({ setLoading }, {});
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    setLoadedCars(cars);
  }, [cars]);

  useTabActive(SideBarTabs.Cars.name);

  const handleOnSearchValueChange = (e: any) => {
    setSearchValue(e.target.value);
  };

  const handleSearchKeydown = (e: any) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    const response = await getCars(
      { search: searchValue.trim(), setLoading },
      { local: true }
    );
    if (response) setLoadedCars(response);
  };

  const handleLoadMore = async () => {
    if (!searchValue) {
      await getCars(
        { offset: loadedCars.length, setLoading: setLoadingMore },
        { more: true }
      );
    } else {
      const response = await getCars(
        {
          offset: loadedCars.length,
          search: searchValue.trim(),
          setLoading: setLoadingMore,
        },
        { local: true }
      );
      if (response) setLoadedCars([...loadedCars, ...response]);
    }
  };

  const { searchPlaceholder } = AppCopy.carScreens;

  return (
    <div className={`${CommonStyles.pageWrapper} ${ClassName.container}`}>
      <Menu />
      <PageHeader
        title="Cars"
        description="Search and manage all marketplace listings."
      />
      <SearchBar
        onKeyDown={handleSearchKeydown}
        onSearch={handleSearch}
        value={searchValue}
        onChange={handleOnSearchValueChange}
        placeholder={searchPlaceholder}
      />
      <div className={ClassName.content}>
        {loading && !loadedCars.length ? (
          <div className="flex min-h-40 items-center justify-center">
            <div className="primaryLoader" />
          </div>
        ) : null}
        {!loading && !loadedCars.length ? (
          <EmptyState
            title="No cars found"
            description="Try a different tag, model, owner, or phone number."
          />
        ) : null}
        {loadedCars.map((car) => (
          <CarCard key={String(car._id)} car={car} />
        ))}

        {loadedCars && loadedCars.length > 19 && (
          <LoadMoreButton onClick={handleLoadMore} loading={loadingMore} />
        )}
      </div>
    </div>
  );
}

export default CarsPage;

const ClassName = {
  container: "flex flex-1 flex-col gap-4",
  content:
    "flex min-h-56 flex-col rounded-2xl border border-slate-200 bg-white p-2 sm:p-4",
};
